import Link from 'next/link'
import React from 'react'
import { Trans } from '../../../components/index'
import MyImage from '../../atoms/MyImage/MyImage'
import { getFileNameFromUrl, trackingDownload } from '../../../utils/gtm'

const MaterialePromozionaleTemplate = (props) => {
  const materiale = props.materialePromozionale
    .filter((obj) => obj.is_active)
    .map((obj) => {
      return obj.materiali_promozionali.map((item) => {
        return (
          <div id={item.id} className="materiale-promozionale__item">
            <div className="materiale-promozionale-card">
              <div className="materiale-promozionale-card">
                {item.file_url ? (
                  <Link href={item.file_url}>
                    <a
                      onClick={() => {
                        trackingDownload('materiali_promozionali', getFileNameFromUrl(item.file_url) ?? item.titolo)
                      }}
                    >
                      <MyImage
                        src={item.immagine_url}
                        alt={item.titolo}
                        layout="responsive"
                        width={290}
                        height={325}
                      />
                    </a>
                  </Link>
                ) : (
                  <a>
                    <MyImage
                      src={item.immagine_url}
                      alt={item.titolo}
                      layout="responsive"
                      width={260}
                      height={290}
                    />
                  </a>
                )}
              </div>
              <h3 className="materiale-promozionale-card__title">{item.titolo}</h3>
              <p className="materiale-promozionale-card__description">{item.descrizione}</p>
            </div>
          </div>
        )
      })
    })
  return props.materialePromozionale.length ? (
    <div className="w-container">
      <div className="materiale-promozionale">
        <h2 className="materiale-promozionale__title">
          <Trans chiave="Materiali promozionali" />
        </h2>
        <br />
        <div className="materiale-promozionale__list">{materiale}</div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default MaterialePromozionaleTemplate

export const MaterialePromozionaleCard = ({ item }) => {
  return (
    <div
      id={item.id}
      className="materiale-promozionale__item"
      style={{ marginRight: 15, marginBottom: 10 }}
    >
      <div className="materiale-promozionale-card">
        <div className="materiale-promozionale-card" style={{ minHeight: 290, minWidth: 260 }}>
          {item.file_url ? (
            <Link href={item.file_url}>
              <a
                onClick={() => {
                  trackingDownload('materiali_promozionali', getFileNameFromUrl(item.file_url) ?? item.titolo)
                }}
              >
                <MyImage
                  src={item.immagine_url}
                  alt={item.titolo}
                  layout="responsive"
                  width={290}
                  height={325}
                />
              </a>
            </Link>
          ) : (
            <a>
              <MyImage
                src={item.immagine_url}
                alt={item.titolo}
                layout="responsive"
                width={260}
                height={290}
              />
            </a>
          )}
        </div>
        <h3 className="materiale-promozionale-card__title">{item.titolo}</h3>
        <p className="materiale-promozionale-card__description">{item.descrizione}</p>
      </div>
    </div>
  )
}
